var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 49.116,
    viewBox: "0 0 40 49.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.414 -2.987)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.414 2.987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.17,18.006c-.686.686-1.372,1.258-2.059,1.83A10.766,10.766,0,0,0,46.17,36.764c1.487.915,1.487.686.8,2.4a30.149,30.149,0,0,1-5.6,8.921c-2.4,2.631-4.689,3.2-8.006,1.83A10.888,10.888,0,0,0,26.041,49a23.954,23.954,0,0,0-2.631.915c-3.546,1.372-5.719.8-8.235-2.059a31,31,0,0,1-6.748-12.7,22.524,22.524,0,0,1-.343-12.009,12.492,12.492,0,0,1,9.15-9.493A10.388,10.388,0,0,1,23.41,14c5.261,1.944,3.774,1.944,8.921,0,5.147-1.83,10.294-.572,13.5,3.431C45.942,17.663,46.056,17.778,46.17,18.006Z",
    transform: "translate(-7.414 -1.522)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9,14.1c-.343-5.6,4.8-11.437,9.722-11.094C35.539,8.034,30.506,14.553,24.9,14.1Z",
    transform: "translate(-4.903 -2.987)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon-apple.6f922749.svg";
export { ForwardRef as ReactComponent };